import type { FilterCableRows } from "./types";

/** The tag rule this whole surface joins on: "-32F4", "32F4" and "32 f4" are one
 * name. Applied to the query AND the row, so he never has to type the dash. */
const normalizeTag = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

export const filterCableRows: FilterCableRows = ({
  items,
  query,
  circuitKeys,
  circuitBreakers,
}) => {
  const wanted = normalizeTag(query);
  if (!wanted) return items;
  return items.filter((item) => {
    const circuitId = item.circuit;
    // Every string the ROW prints, and nothing it does not: what he can read
    // down the list is what he can find in it.
    const searchable = [
      circuitId ? circuitKeys?.[circuitId] : undefined,
      circuitId ? circuitBreakers?.[circuitId] : undefined,
      item.text,
      item.cable_type,
      item.board,
    ];
    return searchable.some(
      (value) => !!value && normalizeTag(value).includes(wanted),
    );
  });
};
